/**
 * De melding na "Uitnodiging versturen" of "Opnieuw versturen", volgens wat er echt gebeurde.
 *
 * De uitnodiging bestaat ook als de mail niet aankwam (de mailserver weigerde, of het adres valt
 * buiten de lijst van een testomgeving); de server zegt dat in `mailStatus`. Een groene "De
 * uitnodiging is verstuurd." terwijl de lijst "Mail niet verzonden" toont, laat de beheerder denken
 * dat de collega een mail kreeg (hertest 29 okt.).
 */
export function invitationToast(
  invitation: { mailStatus?: 'sent' | 'failed' | null } | null | undefined,
  resent = false,
): {
  key: 'invitations.sentToast' | 'invitations.resentToast' | 'invitations.mailFailedToast';
  failed: boolean;
} {
  if (invitation?.mailStatus === 'failed') {
    return { key: 'invitations.mailFailedToast', failed: true };
  }
  return { key: resent ? 'invitations.resentToast' : 'invitations.sentToast', failed: false };
}
